module.exports = __webpack_public_path__ + "img/model_45_ug.6e07d7b8.jpg";